import React from 'react';
import NotificationsSetup from './NotificationsSetup';
import BaseModal, {
	BaseModalProps,
} from '../../Base/Components/BaseModal/BaseModal';

const NotificationsSetupModal: React.FC<BaseModalProps> = props => {
	return (
		<BaseModal {...props} title='component.notificationsSetupButton.title'>
			<NotificationsSetup />
		</BaseModal>
	);
};

export default NotificationsSetupModal;
